/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-21
 * @description Implementation of the GraphQL query to retrieve a featured list collection.
 * @filename featured-list-collection-query.ts
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL query to retrieve list of type Fixed or Dynamic List.
 *
 * @type {GraphQLTaggedNode}
 */
export const FEATURED_LIST_COLLECTION_QUERY: GraphQLTaggedNode = graphql`
query featuredListCollectionQuery($id: ID!) {
  listCollection(id: $id) {
    errors {
      created
      id
      location
      type
    }
    hasErrors
    listCollection {
      __typename
      description
      id
      label
      badges {
        imageLink
        link
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                files {
                  name
                  path
                }
                topLevelMediaType {
                  kind
                }
              }
            }
          }
        }
      }
      previews {
        edges {
          preview {
            mediaAsset {
              id
              files {
                name
                path
              }
              topLevelMediaType {
                kind
              }
            }
            link
            kind
          }
        }
      }
      name
      subTitle
      title
      revision
    }
  }
}
`;
